import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const NextIcon = (props: SvgIconProps) => (
  <NavigateNextOutlinedIcon {...props} fontSize="small" />
);

export default NextIcon;
